import LogoDarkImage from '../assets/images/logo-dark.svg';

const AuthLayout: React.FC = ({ children }) => {
  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed vh-100 auth-bg'>
      <div className='container'>
        <div className='pt-10 pb-5'>
          <img src={LogoDarkImage} alt='Logo' style={{ width: '130px' }} />
        </div>
        <div className='row'>
          <div className='col-md-5 mt-20vh'>
            <h1>Doing Good Is Profitable</h1>
            <p>Technology is transforming banking, payments, and identity verification. Why not mortgage? In developing markets of Africa and Asia where the demands for housing finance exceed the capacity of local banking institutions, MortFi empowers global communities to invest in and with each other.</p>
          </div>
          <div className='col-md-7'>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
